import styled, { css } from 'styled-components/macro'
import Box from '@material-ui/core/Box'

export const Wrapper = styled.div`
  width: 100%;
`
export const NomeSecao = styled.h1`
  ${({ theme }) => css`
    color: ${theme.colors.black};
    font-weight: ${theme.font.extraBold};
    font-size: ${theme.font.sizes.medium};
  `}
  margin-bottom: 24px;
`

export const SecaoOpcional = styled.span`
  ${({ theme }) => css`
    color: ${theme.colors.gray};
    font-size: ${theme.font.sizes.small};
    font-weight: ${theme.font.normal};
  `}
  margin-left: 6px;
`

export const BoxCustomizado = styled(Box)`
  ${({ theme }) => css`
    border: 1px solid ${theme.colors.lightGray};
  `}
  border-radius: 8px;
`

export const GridBotao = styled.div`
  display: grid;
  justify-items: end;
  margin-top: 24px;
`

export const GridBotoes = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 1fr;
  column-gap: 24px;
`
